/* Reading Help: shared behaviour for the article, problem page and placement quiz.
   Klaviyo capture uses the public client endpoints only (no secret key). */
(function () {
  'use strict';

  /* ---------- FAQ accordion (native details, plus schema is in the section) ---------- */
  function scrollBehavior() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
  }
  function wireFaq(root) {
    var items = root.querySelectorAll('details');
    Array.prototype.forEach.call(items, function (d) {
      d.addEventListener('toggle', function () {
        if (d.open) {
          Array.prototype.forEach.call(items, function (o) { if (o !== d && o.open) o.open = false; });
        }
      });
    });
  }

  /* ---------- Placement quiz (Where's My Reader v2 logic, unchanged gates) ---------- */
  function wireQuiz(root) {
    var cq = root.querySelector('[data-rh-quiz-stage]');
    var status = root.querySelector('[data-rh-quiz-status]');
    var doors = {};
    try { doors = JSON.parse(root.querySelector('[data-rh-doors]').textContent); } catch (e) { return; }
    var QUESTIONS = [
      { key: 'age', q: 'First, how old is your child?', o: [['Under 2 and a half', 'baby'], ['2 and a half to 4', 'a1'], ['4 to 6', 'a2'], ['6 to 8', 'a3']] },
      { key: 'rhyme', q: 'Rhyming games, like cat, hat, bat, are...', o: [['New territory', 0], ['Fun, they can spot rhymes', 1], ['Easy, they invent their own', 2]] },
      { key: 'firstsound', q: 'Can your child hear the first sound in a word, like "What sound does sun start with?"', o: [['Not yet', 0], ['Sometimes, with help', 1], ['Easily', 2]] },
      { key: 'letters', q: 'Letter sounds, meaning the sound /s/ and not the name "ess". Your child knows...', o: [['A few or none', 0], ['About half', 1], ['Most or all of them', 2]] },
      { key: 'blend', q: 'If you say a word slowly, like "c... a... t", can they tell you the word?', o: [['Not yet', 0], ['Sometimes, with help', 1], ['Yes, quickly', 2]] },
      { key: 'words', q: 'Short written words like cat, dog and sun...', o: [['They do not try to read them yet', 0], ['They sound them out with help', 1], ['They read them on their own', 2]] },
      { key: 'books', q: 'Simple books, with one short line per page...', o: [['Not yet', 0], ['They read some, with help', 1], ['They read them to you', 2]] }
    ];
    var answers = {}, step = 0, placed = null;

    function esc(v) { return String(v).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

    function place() {
      if (answers.age === 'baby') return 'baby';
      if (answers.rhyme === undefined || answers.firstsound === undefined) return null;
      if (answers.rhyme + answers.firstsound <= 2) return 'd1';
      if (answers.letters === undefined) return null;
      if (answers.letters <= 1) return 'd2';
      if (answers.blend === undefined) return null;
      if (answers.blend <= 1) return 'd3';
      if (answers.words === undefined) return null;
      if (answers.words <= 1) return 'd3';
      if (answers.books === undefined) return null;
      if (answers.books <= 1) return 'd4';
      return 'd5';
    }

    function render(focus) {
      if (placed) return showResult(placed, focus);
      if (step >= QUESTIONS.length) return showResult('d5', focus);
      var q = QUESTIONS[step];
      var pct = Math.round(((step + 1) / QUESTIONS.length) * 100);
      cq.innerHTML =
        '<div class="rh-quiz__bar" role="progressbar" aria-valuemin="1" aria-valuemax="' + QUESTIONS.length + '" aria-valuenow="' + (step + 1) + '" aria-label="Quiz progress"><span style="width:' + pct + '%"></span></div>' +
        '<p class="rh-quiz__count">Question ' + (step + 1) + ' of up to ' + QUESTIONS.length + '</p>' +
        '<h2 class="rh-quiz__q" id="rhQuizQ" tabindex="-1">' + esc(q.q) + '</h2>' +
        '<div class="rh-quiz__opts" role="group" aria-labelledby="rhQuizQ">' +
        q.o.map(function (o, i) { return '<button class="rh-quiz__opt" type="button" data-choice="' + i + '">' + esc(o[0]) + '</button>'; }).join('') +
        '</div>' +
        '<p class="rh-quiz__micro">Your answers suggest an activity to try. This is not a reading assessment. No email is needed to see the suggestion.</p>';
      status.textContent = 'Question ' + (step + 1) + ' of ' + QUESTIONS.length + '. ' + q.q;
      Array.prototype.forEach.call(cq.querySelectorAll('.rh-quiz__opt'), function (b) {
        b.addEventListener('click', function () { answer(Number(b.getAttribute('data-choice'))); });
      });
      if (focus) window.requestAnimationFrame(function () { var t = document.getElementById('rhQuizQ'); if (t) t.focus({ preventScroll: true }); });
    }

    function answer(i) {
      var q = QUESTIONS[step];
      answers[q.key] = q.o[i][1];
      step++;
      placed = place();
      render(true);
      cq.scrollIntoView({ behavior: scrollBehavior(), block: 'start' });
    }

    function showResult(id, focus) {
      var d = doors[id];
      if (!d) return;
      var captureId = 'quiz-' + id;
      cq.innerHTML =
        '<div class="rh-result" style="--accent:' + esc(d.color) + '">' +
        '<p class="rh-eyebrow">A place to start</p>' +
        '<h2 class="rh-result__title" id="rhQuizResult" tabindex="-1">' + esc((d.label ? d.label + ': ' : '') + d.title) + '</h2>' +
        '<p class="rh-result__body">' + esc(d.body) + '</p>' +
        '<div class="rh-card rh-card--plan"><p class="rh-card__head">Try this together</p><ol class="rh-plan">' + d.plan.map(function (p) { return '<li>' + esc(p) + '</li>'; }).join('') + '</ol></div>' +
        '<div class="rh-card rh-card--honest"><p class="rh-card__head">' + esc(d.buy_heading || 'What not to buy yet') + '</p><p>' + esc(d.buy) + '</p></div>' +
        '<div class="rh-result__actions">' +
        (d.cta ? '<a class="rh-btn rh-btn--red" href="' + esc(d.cta[1]) + '">' + esc(d.cta[0]) + '</a>' : '') +
        (d.amazon ? '<a class="rh-btn rh-btn--blue" href="' + esc(d.amazon[1]) + '" target="_blank" rel="noopener">' + esc(d.amazon[0]) + '</a>' : '') +
        '<button class="rh-btn rh-btn--ghost" type="button" data-rh-retake>Retake the quiz</button>' +
        '</div>' +
        (d.download ? '<div class="rh-capture"><p class="rh-capture__head">'+esc(d.download.head)+'</p><p>'+esc(d.download.body)+'</p><a class="rh-btn rh-btn--red" href="'+esc(d.download.url)+'">'+esc(d.download.button)+'</a></div>' : '') +
        '</div>';
      status.textContent = 'Result: ' + (d.label ? d.label + ' ' : '') + d.title + '. ' + d.body;
      var retake = cq.querySelector('[data-rh-retake]');
      if (retake) retake.addEventListener('click', function () { answers = {}; step = 0; placed = null; render(true); cq.scrollIntoView({ behavior: scrollBehavior(), block: 'start' }); });
      if (focus) window.requestAnimationFrame(function () { var t = document.getElementById('rhQuizResult'); if (t) t.focus({ preventScroll: true }); });
    }

    render(false);
  }

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-rh-faq]'), wireFaq);
    Array.prototype.forEach.call(document.querySelectorAll('[data-rh-quiz]'), wireQuiz);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
